import { render } from "./apply.vue?vue&type=template&id=2fe745dc"
const script = {}

import "./apply.vue?vue&type=style&index=0&id=2fe745dc&lang=css"

import exportComponent from "D:\\project\\哨兵官网\\Dtsc.Sentry.Offical.WebSite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__